import React from 'react';
import CommentBanner from '../comment-banner/index.tsx';

// temporary component to call CommentBanner,
// as cshtml cannot render CommentBanner with HOC at the moment
const MobileIdentifierCommentBanner = function MobileIdentifierCommentBanner(props) {
    return <CommentBanner {...props} />;
};

export default MobileIdentifierCommentBanner;
